import { baseTheme } from "@chakra-ui/react";

export const BRAND_COLOR = baseTheme.colors.teal;
